import { c as _c } from "react/compiler-runtime";
import CheckBox from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";
import Clear from "@mui/icons-material/Clear";
import Close from "@mui/icons-material/Close";
import { Box, Button, Checkbox, Divider, FormControlLabel, IconButton, Popover, Stack, ToggleButton, ToggleButtonGroup, Typography, useTheme } from "@mui/material";
import { useSession } from "next-auth/react";
import React from "react";
import { getDifficultyColor } from "#/entities/difficulty/lib/getDifficultyColor";
import { difficultyLabels } from "#/entities/difficulty/model/difficultyLabels";
import { ProjectDifficulty } from "#/server/db/generated/enums";
import { useI18nContext } from "#/shared/hooks";
import { useProjectBrowserContext } from "./ProjectBrowserContext";
type ProjectBrowserFiltersProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
};
export const ProjectBrowserFilters: React.FC<ProjectBrowserFiltersProps> = t0 => {
  const $ = _c(67);
  const {
    anchorEl,
    open,
    onClose
  } = t0;
  const {
    LL
  } = useI18nContext();
  const theme = useTheme();
  const session = useSession();
  const {
    selectedDifficulties,
    showOnlyNew,
    setSelectedDifficulties,
    setShowOnlyNew,
    resetFilters
  } = useProjectBrowserContext();
  let t1;
  if ($[0] !== setSelectedDifficulties) {
    t1 = (_ev, newDifficulties) => {
      setSelectedDifficulties(newDifficulties);
    };
    $[0] = setSelectedDifficulties;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDifficultyToggle = t1;
  let t2;
  if ($[2] !== setShowOnlyNew) {
    t2 = ev => {
      setShowOnlyNew(ev.target.checked);
    };
    $[2] = setShowOnlyNew;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleShowOnlyNewChange = t2;
  let t3;
  if ($[4] !== resetFilters) {
    t3 = () => {
      resetFilters();
    };
    $[4] = resetFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClearAll = t3;
  const hasActiveFilters = selectedDifficulties.length > 0 || showOnlyNew;
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      vertical: "bottom",
      horizontal: "left"
    };
    t5 = {
      vertical: "top",
      horizontal: "left"
    };
    t6 = {
      paper: {
        sx: {
          mt: 1,
          minWidth: 280,
          maxWidth: 320,
          p: 2
        }
      }
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      fontSize: 16,
      fontWeight: 600
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== LL) {
    t9 = LL.FILTERS();
    $[11] = LL;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <Typography variant="h6" sx={t8}>{t9}</Typography>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Close fontSize="small" />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onClose) {
    t12 = <IconButton size="small" onClick={onClose} aria-label="Close filters">{t11}</IconButton>;
    $[16] = onClose;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12) {
    t13 = <Stack direction="row" sx={t7}>{t10}{t12}</Stack>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Divider />;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      mb: 1,
      fontWeight: 600
    };
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== LL) {
    t16 = LL.FILTER_BY_DIFFICULTY();
    $[23] = LL;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16) {
    t17 = <Typography variant="subtitle2" sx={t15}>{t16}</Typography>;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      display: "flex",
      flexWrap: "wrap",
      gap: 0.5,
      "& .MuiToggleButton-root": {
        border: 1,
        borderColor: "divider",
        px: 1.5,
        py: 0.75,
        textTransform: "none",
        "&.Mui-selected": {
          backgroundColor: "primary.main",
          color: "primary.contrastText",
          "&:hover": {
            backgroundColor: "primary.dark"
          }
        },
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: 2
        }
      }
    };
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== selectedDifficulties || $[29] !== theme) {
    t19 = Object.values(ProjectDifficulty).map(difficulty => <ToggleButton key={difficulty} value={difficulty} aria-label={`Filter by ${difficultyLabels[difficulty]} difficulty`} sx={{
      color: selectedDifficulties.includes(difficulty) ? undefined : getDifficultyColor(theme, difficulty)
    }}>{difficultyLabels[difficulty]}</ToggleButton>);
    $[28] = selectedDifficulties;
    $[29] = theme;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== handleDifficultyToggle || $[32] !== selectedDifficulties || $[33] !== t19) {
    t20 = <ToggleButtonGroup value={selectedDifficulties} onChange={handleDifficultyToggle} aria-label="Difficulty filter" sx={t18}>{t19}</ToggleButtonGroup>;
    $[31] = handleDifficultyToggle;
    $[32] = selectedDifficulties;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t17 || $[36] !== t20) {
    t21 = <Box>{t17}{t20}</Box>;
    $[35] = t17;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Divider />;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <CheckBoxOutlineBlank />;
    t24 = <CheckBox />;
    $[39] = t23;
    $[40] = t24;
  } else {
    t23 = $[39];
    t24 = $[40];
  }
  let t25;
  if ($[41] !== handleShowOnlyNewChange || $[42] !== showOnlyNew) {
    t25 = <Checkbox checked={showOnlyNew} onChange={handleShowOnlyNewChange} icon={t23} checkedIcon={t24} />;
    $[41] = handleShowOnlyNewChange;
    $[42] = showOnlyNew;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== LL) {
    t26 = LL.SHOW_ONLY_NEW();
    $[44] = LL;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t25 || $[47] !== t26) {
    t27 = <Box><FormControlLabel control={t25} label={t26} /></Box>;
    $[46] = t25;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== LL || $[50] !== session.data) {
    t28 = session.data && <Box><FormControlLabel control={<Checkbox checked={false} disabled={true} icon={<CheckBoxOutlineBlank />} checkedIcon={<CheckBox />} />} label={LL.SHOW_ONLY_MINE()} /><Typography variant="caption" sx={{
        color: "text.secondary",
        ml: 4
      }}>Coming soon</Typography></Box>;
    $[49] = LL;
    $[50] = session.data;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== LL || $[53] !== handleClearAll || $[54] !== hasActiveFilters) {
    t29 = hasActiveFilters && <><Divider /><Button startIcon={<Clear />} onClick={handleClearAll} variant="outlined" size="small" fullWidth={true}>{LL.CLEAR_ALL_FILTERS()}</Button></>;
    $[52] = LL;
    $[53] = handleClearAll;
    $[54] = hasActiveFilters;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t13 || $[57] !== t21 || $[58] !== t27 || $[59] !== t28 || $[60] !== t29) {
    t30 = <Stack spacing={2}>{t13}{t14}{t21}{t22}{t27}{t28}{t29}</Stack>;
    $[56] = t13;
    $[57] = t21;
    $[58] = t27;
    $[59] = t28;
    $[60] = t29;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] !== anchorEl || $[63] !== onClose || $[64] !== open || $[65] !== t30) {
    t31 = <Popover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={t4} transformOrigin={t5} slotProps={t6}>{t30}</Popover>;
    $[62] = anchorEl;
    $[63] = onClose;
    $[64] = open;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  return t31;
};